import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import OrderStatusClass from '../../../types/order/OrderStatusClass';
import Icon from '../../common/Icon';

import styles from '../../../styles/_exports.scss';

const OrderStatusLabel = ({ status }) => {
  const labels = useMemo(() => ({
      [OrderStatusClass.PROCESSING]: (
        <FormattedMessage id="orderStatus.processing" defaultMessage="Processing"/>
      ),
      [OrderStatusClass.READY]: (
        <FormattedMessage id="orderStatus.ready" defaultMessage="Ready"/>
      ),
      [OrderStatusClass.CANCELED]: (
        <FormattedMessage id="orderStatus.canceled" defaultMessage="Canceled"/>
      ),
      [OrderStatusClass.PENDING]: (
        <FormattedMessage id="orderStatus.pending" defaultMessage="Pending"/>
      ),
      [OrderStatusClass.ACTIVE]: (
        <FormattedMessage id="orderStatus.active" defaultMessage="Active"/>
      ),
      [OrderStatusClass.DEACTIVATED]: (
        <FormattedMessage
          id="orderStatus.deactivated"
          defaultMessage="Deactivated"
        />
      ),
      [OrderStatusClass.ON_HOLD]: (
        <FormattedMessage id="orderStatus.onHold" defaultMessage="On hold"/>
      ),
      [OrderStatusClass.PAYMENT_CONFIRMED]: (
        <FormattedMessage
          id="orderStatus.paymentConfirmed"
          defaultMessage="Payment Confirmed"
        />
      ),
      [OrderStatusClass.PAYMENT_DENIED]: (
        <FormattedMessage
          id="orderStatus.paymentDenied"
          defaultMessage="Payment Denied"
        />
      ),
      [OrderStatusClass.PAYMENT_PENDING]: (
        <FormattedMessage
          id="orderStatus.paymentPending"
          defaultMessage="Payment Pending"
        />
      ),
    }),
    []
  );

  const getColor = () => {
    switch (status) {
      case OrderStatusClass.CANCELED:
      case OrderStatusClass.DEACTIVATED:
      case OrderStatusClass.PAYMENT_DENIED:
        return styles['danger'];
      case OrderStatusClass.PENDING:
      case OrderStatusClass.PROCESSING:
      case OrderStatusClass.ON_HOLD:
      case OrderStatusClass.PAYMENT_PENDING:
      case OrderStatusClass.PAYMENT_CONFIRMED:
        return styles['warning'];
      case OrderStatusClass.READY:
      case OrderStatusClass.ACTIVE:
        return styles['success'];
      default:
        return null;
    }
  };

  const statusMessage = labels[status];

  return statusMessage ? (
    <span
      className="OrderStatusLabel"
      style={{
        display: 'flex',
        alignItems: 'center',
        color: getColor(),
      }}
    >
      <Icon className="OrderStatusLabel__status-icon" name="circle" />
      &nbsp;
      {statusMessage}
    </span>
  ) : null;
}

OrderStatusLabel.propTypes = {
  status: PropTypes.oneOf(Object.values(OrderStatusClass)),
};

export default OrderStatusLabel;
